import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar, CheckSquare, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
export const DailySidebar = () => {
  const navigate = useNavigate();
  const {
    orgId
  } = useAuth();
  const [todayEvents, setTodayEvents] = useState<any[]>([]);
  const [todayTasks, setTodayTasks] = useState<any[]>([]);
  useEffect(() => {
    if (!orgId) return;
    const fetchTodayData = async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Fetch today's events
      const {
        data: events
      } = await supabase.from('calendar_events').select('*').eq('org_id', orgId).gte('start_time', today.toISOString()).lt('start_time', tomorrow.toISOString()).order('start_time', {
        ascending: true
      }).limit(3);
      if (events) setTodayEvents(events);

      // Fetch today's tasks
      const {
        data: tasks
      } = await supabase.from('tasks').select('*').eq('org_id', orgId).gte('due_date', today.toISOString()).lt('due_date', tomorrow.toISOString()).order('due_date', {
        ascending: true
      }).limit(4);
      if (tasks) setTodayTasks(tasks);
    };
    fetchTodayData();
  }, [orgId]);
  return <div className="space-y-4">
      {/* Today's Schedule */}
      <Card className="rounded-2xl">
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-bold flex items-center gap-2">
              <Calendar className="w-4 h-4 text-primary" />
              Today's Schedule
            </h3>
            <Button size="sm" variant="ghost" className="h-7 px-2" onClick={() => navigate('/calendar')}>
              View All
            </Button>
          </div>
          
          {todayEvents.length === 0 ? <p className="text-xs text-muted-foreground py-2">
              No events scheduled today
            </p> : <div className="space-y-2">
              {todayEvents.slice(0, 3).map(event => <div key={event.id} className="p-2 bg-muted/50 rounded-lg">
                  <div className="flex items-start justify-between gap-2">
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-medium truncate">{event.title}</p>
                      <p className="text-[10px] text-muted-foreground">
                        {new Date(event.start_time).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                      </p>
                    </div>
                    <Badge variant="outline" className="text-[10px] px-1.5 py-0">
                      {event.event_type}
                    </Badge>
                  </div>
                </div>)}
            </div>}
        </CardContent>
      </Card>

      {/* Your Tasks */}
      <Card className="rounded-2xl">
        <CardContent className="p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-sm font-bold flex items-center gap-2">
              <CheckSquare className="w-4 h-4 text-primary" />
              Your Tasks
            </h3>
            <Button size="sm" variant="ghost" className="h-7 w-7 p-0" onClick={() => navigate('/jobs')}>
              <Plus className="w-4 h-4" />
            </Button>
          </div>
          
          {todayTasks.length === 0 ? <p className="text-xs text-muted-foreground py-2">
              No tasks for today
            </p> : <div className="space-y-2">
              {todayTasks.slice(0, 4).map(task => <div key={task.id} className="flex items-start gap-2 p-2 bg-muted/50 rounded-lg">
                  <input type="checkbox" className="mt-0.5" checked={task.completed} readOnly />
                  <div className="flex-1 min-w-0">
                    <p className={`text-xs ${task.completed ? 'line-through text-muted-foreground' : ''}`}>
                      {task.title}
                    </p>
                    {task.due_date && <p className="text-[10px] text-muted-foreground">
                        Due: {new Date(task.due_date).toLocaleDateString()}
                      </p>}
                  </div>
                </div>)}
            </div>}
        </CardContent>
      </Card>

      {/* Quick Actions */}
      <Card className="rounded-2xl bg-gradient-to-br from-primary/10 to-primary/5">
        
      </Card>
    </div>;
};